module.exports = '1.6.1';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 89
// module chunks = 0